import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import JobOrderLpoForm from '../../components/pageModule/Joborderlpos/JobOrderLpoForm';
import { createJobOrderLpo, setSelected, clearCurrentJobOrderLpo } from '../../store/modules/joborderlpo/joborderlpoActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const JoborderlposCreate = () => {
    const joborderState = useSelector(state => state.joborderlpo);
    const initialData = useRef({ 
        initialType: 'create',
        order_date: new Date().toISOString().split('T')[0],
        trial_date: new Date().toISOString().split('T')[0],
        due_date: new Date().toISOString().split('T')[0],
    });
    const [formKey, setFormKey] = useState(0); // Add key state
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Clear any existing data when component mounts
    useEffect(() => {
        dispatch(clearCurrentJobOrderLpo());
    }, [dispatch]);

    const handleCreate = async (formData) => {
        try {
            const response = await dispatch(createJobOrderLpo(formData));
            toast.success('Job order lpo created successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            if (response && response.id) {

                navigate(`/job_order_lpos/view/${response.id}?preview=true`);

                // Reset initialData and force remount
                // initialData.current = { 
                //     initialType: 'create',
                //     order_date: new Date().toISOString().split('T')[0],
                //     trial_date: new Date().toISOString().split('T')[0],
                //     due_date: new Date().toISOString().split('T')[0],
                //     address1: formData.address1,
                //     address2: formData.address2,
                //     country: formData.country,
                //     customer: formData.customer,
                //     customer_name: formData.customer_name,
                //     is_domestic: formData.is_domestic,
                //     is_locked : false,
                //     is_lpo: true,
                //     lpo_number: formData.lpo_number,
                //     phone_number: formData.phone_number,
                //     vat_group: formData.vat_group,
                //     vat_number: formData.vat_number,
                // };
                // setFormKey(prev => prev + 1);


                // Optionally, you can navigate or just reset the form
                // navigate(`/job_order_lpos/create`);
            }
            return response;
        } catch (error) {
            toast.error(error.message || 'Error creating job order lpo', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
    };
    
    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <JobOrderLpoForm 
                                    key={formKey} // Force remount on key change
                                    initialData={initialData.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.create(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}
export default JoborderlposCreate; 